import type { ClaimWithRelations } from "../api/use-claim";

export type ClaimTypeName = ClaimWithRelations["claimType"]["name"];

/** Mirrors BadgeClaimType.vue + getDisplayName (Vue). */
export const claimTypeBadgeClasses: Record<ClaimTypeName, string> = {
  FLIGHT_DELAY: "bg-orange-50 text-orange-700 ring-orange-600/10",
  FLIGHT_CANCELLATION: "bg-red-50 text-red-700 ring-red-600/10",
  PNR_SEGMENT_CANCELLATION: "bg-red-50 text-red-700 ring-red-600/10",
  DELAY_FROM_PNR_SCHEDULE: "bg-amber-50 text-amber-700 ring-amber-600/10",
  MISSED_CONNECTION_DUE_TO_DELAY: "bg-indigo-50 text-indigo-700 ring-indigo-600/10",
  CONNECTION_DISRUPTION: "bg-teal-50 text-teal-700 ring-teal-600/10",
  OVERBOOKING: "bg-violet-50 text-violet-700 ring-violet-600/10",
  WRONG_ARRIVAL_AIRPORT: "bg-teal-50 text-teal-700 ring-teal-600/10",
  COVID_ORDINANCE_2020: "bg-blue-50 text-blue-700 ring-blue-600/10",
};

const claimTypeDisplay: Record<ClaimTypeName, { text: string; emoji: string }> = {
  FLIGHT_CANCELLATION: { text: "Annulation", emoji: "❌ " },
  PNR_SEGMENT_CANCELLATION: { text: "Annulation Segment", emoji: "🛑 " },
  FLIGHT_DELAY: { text: "Retard", emoji: "🕓 " },
  DELAY_FROM_PNR_SCHEDULE: { text: "Retard PNR", emoji: "♻️ " },
  MISSED_CONNECTION_DUE_TO_DELAY: { text: "Correspondance manquée (Retard)", emoji: "🛄 " },
  CONNECTION_DISRUPTION: { text: "Rupture de correspondance", emoji: "✂️ " },
  WRONG_ARRIVAL_AIRPORT: { text: "Mauvais aéroport d'arrivée", emoji: "📍 " },
  OVERBOOKING: { text: "Surbooking", emoji: "🎫 " },
  COVID_ORDINANCE_2020: { text: "Ordonnance Covid mars 2020", emoji: "🇫🇷 " },
};

export function getClaimTypeDisplayName(type: ClaimTypeName, settings?: { emoji: boolean }): string {
  const { text, emoji } = claimTypeDisplay[type];
  return (settings?.emoji ? emoji.concat(" ") : "") + text;
}

/** Claim types displayed with the "cancellation" red accent (Vue conditionals). */
export function isCancellationLikeClaimType(type: ClaimTypeName | null): boolean {
  return type === "FLIGHT_CANCELLATION" || type === "PNR_SEGMENT_CANCELLATION" || type === "OVERBOOKING";
}
